import * as BCrypt from 'bcryptjs';
import { AxiosResponse } from 'axios';

import { encrypt } from '../utils/encryption'

import { axiosAssetDashApi} from './api';

export interface ArcadeGameSession {
  id: string;
  created: string; 
  start_time: string | null;
  end_time: string | null;
  arcade_game_id: string;
  spent_coins: number | null;
  earned_coins: number | null;
}
export interface ArcadeStartSessionResponse {
  arcade_game_session: ArcadeGameSession;
}

export const postStartArcadeGameSession = async (arcadeGameId: string): Promise<AxiosResponse<ArcadeStartSessionResponse>> => {
  return await axiosAssetDashApi.post('/api/api_v4/games/arcade/games/start_session', {
    arcade_game_id: arcadeGameId,
  });
};

export const postCompleteArcadeGameSession = async (arcadeGameId: string, arcadeGameSessionId: string, data: object = {}): Promise<
  AxiosResponse<ArcadeStartSessionResponse>
> => {
  const salt = "$2b$12$AMak54pHWLvQj/gjrm0kNO"
  const encryptedData = encrypt(data);
  const hash = await BCrypt.hash(arcadeGameSessionId + encryptedData, salt)
  const sessionHash = hash.toString().replace(salt, '');

  return await axiosAssetDashApi.post('/api/api_v4/games/arcade/games/complete_session', {
    arcade_game_id: arcadeGameId,
    arcade_game_session_id: arcadeGameSessionId,
    session_hash: sessionHash,
    data: encryptedData
  });
};

export interface ArcadeGame {
  id: string;
  game_id: string;
  name: string;
  status: string;
  description: string;
  image_url: string;
  game_url: string;
  cost_coins: number;
  instructions: string[];
  scoring_instructions: string[];
  tags: ArcadeGameTag[];
  instructions_link: string;
  terms_link: string;
}

export interface ArcadeGameTag {
  id: string;
  name: string;
}

export const getArcadeGames = (tag?: string): Promise<
  AxiosResponse<{ arcade_games: ArcadeGame[] }>
> => {
  const params = {
    ...(tag && { tag_ids: tag }),
  };
  return axiosAssetDashApi.get('/api/api_v4/games/arcade/games/list', {params});
}

export const getArcadeGameDetail = (arcadeGameId: string): Promise<
  AxiosResponse<{
    arcade_game: ArcadeGame;
  }>
> => {
  return axiosAssetDashApi.get(`/api/api_v4/games/arcade/games/${arcadeGameId}`);
}